<template>
  <el-dialog
    :visible="visible"
    fullscreen
    :show-close="false"
    custom-class="doc-preview-modal"
    @update:visible="$emit('update:visible', $event)"
  >
    <div class="doc-preview-modal__header">
      <p class="doc-preview-modal__title">
        {{ document ? document.name : "" }}
      </p>
      <div class="doc-preview-modal__actions">
        <button
          v-if="canEditPdf"
          class="btn md__btn-third-secondary"
          @click="$emit('edit-pdf')"
        >
          <i class="el-icon-edit"></i> Editar PDF
        </button>
        <button
          v-if="canSign"
          class="btn md__btn-primary"
          @click="$emit('sign')"
        >
          <i class="el-icon-edit-outline"></i> Firmar documento
        </button>
        <button
          class="doc-preview-modal__close"
          @click="$emit('update:visible', false)"
        >
          <i class="el-icon-close"></i>
        </button>
      </div>
    </div>

    <div class="doc-preview-modal__body">
      <div v-if="loading" class="doc-preview-modal__state">
        <i class="el-icon-loading"></i>
        <span>Cargando vista previa...</span>
      </div>
      <PdfViewer v-else-if="pdfData" :pdfData="pdfData" />
      <div v-else class="doc-preview-modal__state">
        <i class="el-icon-document"></i>
        <span>No se pudo cargar la vista previa.</span>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import PdfViewer from "./PdfViewer.vue";

export default {
  name: "DocumentPreviewModal",
  components: { PdfViewer },
  props: {
    visible: { type: Boolean, default: false },
    document: { type: Object, default: null },
    pdfData: { type: [ArrayBuffer, Uint8Array], default: null },
    loading: { type: Boolean, default: false }
  },
  computed: {
    canEditPdf() {
      return (
        !!this.document &&
        this.document.status === "draft" &&
        this.document.source === "upload"
      );
    },
    canSign() {
      return !!this.document && this.document.status === "draft";
    }
  }
};
</script>

<style>
.doc-preview-modal.el-dialog {
  margin: 0 !important;
  border-radius: 0;
  display: flex;
  flex-direction: column;
}
.doc-preview-modal .el-dialog__header,
.doc-preview-modal .el-dialog__body {
  padding: 0;
}
</style>

<style scoped>
.doc-preview-modal__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 24px;
  background: #fff;
  border-bottom: 1px solid #e8e7e3;
}

.doc-preview-modal__title {
  font-size: 16px;
  font-weight: 600;
  color: #1f2937;
  margin: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.doc-preview-modal__actions {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-shrink: 0;
}

.doc-preview-modal__close {
  border: none;
  background: none;
  font-size: 20px;
  cursor: pointer;
  color: #6b7280;
  padding: 4px 8px;
  border-radius: 6px;
}

.doc-preview-modal__close:hover {
  background: #f3f4f6;
}

.doc-preview-modal__body {
  height: calc(100vh - 65px);
  background: #f0f2f5;
}

.doc-preview-modal__state {
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  color: #989aae;
  font-size: 14px;
}

.doc-preview-modal__state i {
  font-size: 32px;
}
</style>
